// Check if fbq is available
const isFbPixelInitialized = () => {
  return typeof window !== 'undefined' && window.fbq;
};

// Track a custom event
export const trackCustomEvent = (eventName, eventData = null) => {
  if (isFbPixelInitialized()) {
    if (eventData) {
      window.fbq('track', eventName, eventData);
    } else {
      window.fbq('track', eventName);
    }
  }
};

// Track form submission
export const trackFormSubmission = (formData) => {
  trackCustomEvent('SubmitApplication', {
    content_name: 'Master IA & IoT Application',
    status: 'submitted',
    education_level: 'Master',
    program: 'Intelligence Artificielle et IoT'
  });
};

// Track form start
export const trackFormStart = () => {
  trackCustomEvent('InitiateCheckout', {
    content_name: 'Master IA & IoT Application',
    content_category: 'Education'
  });
};

// Track successful form submission
export const trackFormSuccess = () => {
  trackCustomEvent('CompleteRegistration', {
    content_name: 'Master IA & IoT Application',
    status: 'success',
    education_level: 'Master',
    program: 'Intelligence Artificielle et IoT'
  });
};

// Track when user views program details
export const trackProgramView = () => {
  trackCustomEvent('ViewContent', {
    content_name: 'Master IA & IoT Details',
    content_category: 'Education',
    content_type: 'product'
  });
};

// Track when user clicks contact information
export const trackContactClick = (contactType) => {
  trackCustomEvent('Contact', {
    content_name: 'Master IA & IoT Contact',
    contact_type: contactType // 'phone' or 'email'
  });
}; 